import { gql } from '@apollo/client';

const UPDATE_STUDY_PATIENT_CONTACT = gql`
  mutation updateStudyPatientContact($input: UpdateStudyPatientContactInput!) {
    updateStudyPatientContact(input: $input) {
      isSuccess
      message
    }
  }
`;

export default UPDATE_STUDY_PATIENT_CONTACT;
